
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0C315E","d":"M22.531 24.625a1.97 1.97 0 001.969-1.969V11.82c0-.213-.033-.423-.103-.624L22.322 4.97a1.963 1.963 0 00-1.866-1.345H7.544c-.849 0-1.6.541-1.866 1.345l-2.075 6.226c-.066.201-.103.41-.103.624v10.836a1.97 1.97 0 001.969 1.969H22.53zm-9.187-12.797H4.812v-.008c0-.07.013-.14.033-.21l2.076-6.225a.658.658 0 01.623-.447h5.8v6.89zm9.843 0h-8.53v-6.89h5.799c.283 0 .533.18.623.447l2.076 6.226c.02.065.032.135.032.209v.008zm-.656 11.484H5.47a.658.658 0 01-.657-.656v-9.515h18.375v9.515c0 .361-.295.656-.656.656z"}})])
          )
        }
      }
    